<script>
  import {getContext} from 'svelte';
  import {SERVICES} from '@/const/services';
  import {logout$} from '@/streams/auth';
  import Button from '@/widgets/Button.svelte';
  import Modal from '@/widgets/Modal.svelte';
  import lang from './BasicKycDialog.lang';

  const LG = getContext('LG');
  const icon = `${SERVICES.STATIC_URL}/pubimg/9a4c8b7bac33e49bdd74998cd9e7fe32c84405f6121bc6869fa74d0fc66ca95c.png`;

  function handleLogoutClick() {
    logout$.next({manual: true});
    localStorage.removeItem('base-kyc-status');
  }
</script>

<style>
  .icon {
    margin-bottom: 28px;
    width: 80px;
    height: 80px;
  }
  .content {
    margin-bottom: 16px;
    font-size: 16px;
    color: #777b83;
  }
  @media screen and (max-width: 640px) {
    .icon {
      margin-bottom: 20px;
    }
    .content {
      margin-bottom: 20px;
      font-size: 14px;
    }
  }
</style>

<Modal visible>
  <div class="tc">
    <img class="icon" src={icon} alt="info-icon" />
    <div class="content f16">{LG(lang.SubLogout)}</div>
    <Button class="f16" newRadius type="primary" on:click={handleLogoutClick}>{LG(lang.Logout)}</Button>
  </div>
</Modal>
